import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Event, EventWithVenue, EventBasicData, SeasonEventRef, EventMinData } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

@Injectable()
export class EventApi {
	private _eventsByMerchantId = "/api/events/v2/events"
	private _events = "/api/events/v2/events"
	private _eventApi = "/api/com/events/v1"
	private _eventApiV2 = "/api/events/v2"

	constructor(private httpClient: HttpClient, private logger: Logger) {}

	public setReferences(eventReferenceUrl: string, referencedObjectUrls: string[]) {
		return this.httpClient.putRef(eventReferenceUrl, referencedObjectUrls)

	}
	public getEvents(): Observable<Event[]> {
		return this.httpClient.get(this._eventsByMerchantId + "?projection=basicData&size=1000")
				.map(response => response.json()._embedded.events)
			.catch(this.handleError);
	}

	public getEventById(id: string): Observable<Event> {
		this.logger.info("Get Event by Id:" + id);
		return this.httpClient.get(this._events + "/" + id)
			.map(response => <Event>response.json())
			.catch(this.handleError);
	}

	public createEvent(event: Event): Observable<Event> {
		let body = JSON.stringify(event);
		this.logger.info("Save Event: " + event.title);
		return this.httpClient.post(this._events, body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public patchEvent(id: string, event: Event): Observable<Event> {
		let body = JSON.stringify(event);
		this.logger.info("Update Event[" + id + "]: " + event.title);
		return this.httpClient.patch(this._events + "/" + id, body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public patchEventSpecificProperties(id: string, props: {}): Observable<Event> {
		let body = JSON.stringify(props);
		this.logger.info("Update Event[" + id + "]");
		return this.httpClient.patch(this._events + "/" + id, body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public deleteEvent(id: string): Observable<Response> {
		this.logger.info("Delete Event[" + id + "]");
		return this.httpClient.delete(this._events + "/" + id)
			.catch(this.handleError)
	}

	public transitionLifecycle(url: string, newPhase: string): Observable<Event> {
		let body = JSON.stringify(newPhase);
		return this.httpClient.patch(url, body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public transitionLifecycleSupport(eventId: string, newPhase: string): Observable<Event> {
		let body = JSON.stringify(newPhase);
		return this.httpClient.patch(this._events + "/" + eventId + "/transitionLifecycleSupport" , body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public cancelEvent(url: string, messageFromMerchant: string): Observable<Event> {
		let body = JSON.stringify(messageFromMerchant);
		return this.httpClient.post(url, body)
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public allowEventDistribution(id: string) {
		this.logger.info("Allow Distribution Event[" + id + "]");
		return this.httpClient.post(this._events + "/" + id + "/allowEventDistribution")
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public denyEventDistribution(id: string) {
		this.logger.info("Deny Distribution Event[" + id + "]");
		return this.httpClient.post(this._events + "/" + id + "/denyEventDistribution")
			.map(response => <Event>response.json())
			.catch(this.handleError)
	}

	public overview(lifecycle?: string): Observable<EventWithVenue[]> {
		const param = lifecycle ? "?lifecyclePhase=" + lifecycle : ""
		return this.httpClient.get(this._eventApi + "/overview" + param)
				.map(response => response.json())
			.catch(this.handleError);
	}

	public getEventsForSponsoring(): Observable<EventMinData[]> {
		return this.httpClient.get(this._eventApiV2 + "/minimalEventInfo")
			.map(response => response.json())
			.catch(this.handleError);
	}

	public findByUuid(uuid: string): Observable<Event> {
		return this.httpClient.get(this._events + "/search/findByUuid?uuid=" + uuid)
			.map(response => response.json())
			.catch(this.handleError);
	}

	public findBySeatingplanUUID(uuid: string): Observable<Event[]> {
		return this.httpClient.get(this._events + "/search/findBySeatingplanUuid?seatingplanUuid=" + uuid)
			.map(response => response.json()._embedded.events)
			.catch(this.handleError);
	}

	public findBySeasonEventProperty(): Observable<EventBasicData[]> {
		return this.httpClient.get(
			this._events +
			"/search/findBySeasonEventAndLifecycleStateTransition_LifecyclePhaseNotIn?" +
			"isSeasonEvent=true&lifeCyclePhases=FINISHED,CANCELED&projection=basicData")
				.map(response => response.json()._embedded.events)
				.catch(this.handleError);
	}

	public setSeasonEventRef(seasonEventsStorageIds: number[], id: string): Observable<SeasonEventRef> {
		let body = JSON.stringify(seasonEventsStorageIds);
		let url =  this._events + "/" + id + "/seasonEventRef";
		return this.httpClient.post(url, body)
			.map(response => <SeasonEventRef>response.json())
			.catch(this.handleError);
	}

	public getSeasonEventRef(id: string): Observable<SeasonEventRef> {
		let url =  this._events + "/" + id + "/seasonEventRef";
		return this.httpClient.get(url)
			.map(response => response.json())
			.catch(this.handleError);
	}

	public getOneTimeEvents(id: string): Observable<EventBasicData[]> {
		let url =  this._events + "/" + id + "/seasonEventRef/oneTimeEvents";
		return this.httpClient.get(url)
			.map(response => response.json())
			.catch(this.handleError);
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/event-api.service.ts